import ApiBase, { baseUrl } from '.';

export default class UserCourseServiceApi extends ApiBase {
  constructor(token) {
    super(`${baseUrl}/api/services/app/UserCourseService`, token);
  }

  getUserCourses(name = '', skipCount = 0, maxResultCount = 10) {
    return this.authHttp.get(`${this.baseUrl}/GetUserCourses`, {
      params: {
        Name: name,
        SkipCount: skipCount,
        MaxResultCount: maxResultCount
      }
    });
  }

  getCourseExecution(id) {
    return this.authHttp.get(`${this.baseUrl}/GetCourseExecution`, {
      params: { courseAssignmentId: id }
    });
  }

  startCourseExecution(id) {
    return this.authHttp.post(
      `${this.baseUrl}/StartCourseExecution`,
      {},
      { params: { courseAssignmentId: id } }
    );
  }

  startElementExecution(id) {
    return this.authHttp.post(
      `${this.baseUrl}/StartElementExecution`,
      {},
      { params: { elementExecutionId: id } }
    );
  }

  saveElementExecution(element) {
    return this.authHttp.post(`${this.baseUrl}/SaveElementExecution`, element);
  }

  finishElementExecution(element) {
    return this.authHttp.post(
      `${this.baseUrl}/FinishElementExecution`,
      element
    );
  }

  getFinishedUserCourses(name = '', skipCount = 0, maxResultCount = 10) {
    return this.authHttp.get(`${this.baseUrl}/GetFinishedUserCourses`, {
      params: {
        Name: name,
        SkipCount: skipCount,
        MaxResultCount: maxResultCount
      }
    });
  }
}
